import { useMemo } from 'react';

import * as Yup from 'yup';

import {
  calculateDocumentTriggers,
  calculateExpertTriggers,
  createInitialValues,
  createValidationSchema,
} from 'components/NEComponents/NESteps/NEStepFormUpload/NEFormUploadIVFunctions';

export const useNEFormUploadIV = (valuesFirstPage, installerEntry, branchSelectionValues) => {
  return useMemo(() => {
    if (
      !installerEntry ||
      !valuesFirstPage ||
      !valuesFirstPage.experts ||
      valuesFirstPage.experts.length === 0 ||
      !branchSelectionValues
    ) {
      return { initialValues: {}, validationSchema: Yup.object() };
    }
    const expertTriggers = calculateExpertTriggers(valuesFirstPage.experts, branchSelectionValues);
    const documentTriggerIds = calculateDocumentTriggers(branchSelectionValues, installerEntry);

    const initialValues = createInitialValues(
      valuesFirstPage.experts,
      documentTriggerIds,
      expertTriggers,
      branchSelectionValues
    );

    const validationSchema = createValidationSchema(
      initialValues,
      expertTriggers,
      valuesFirstPage.experts,
      branchSelectionValues,
      installerEntry
    );

    return {
      initialValues,
      validationSchema,
      documentTriggerIds,
      expertTriggers,
    };
  }, [valuesFirstPage, installerEntry, branchSelectionValues]);
};
